import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { resolvePersianAndArabicNumbers, resolvePhonePrefix, trimPhone } from '../../../../helpers';
import { connectWithWhatsApp, getUserProile, getWLProfile, saveWLProfile, whatsAppLogout } from '../../../../api/userApi';
import { Alert, Box, Button, CircularProgress, Dialog, DialogContent, DialogTitle, FormControl, FormControlLabel, FormHelperText, Grid, Radio, RadioGroup, Skeleton, Stack, TextField } from '@mui/material';
import LoadingButton from '../../../../components/global-components/loading-btn';
import Replay from '@mui/icons-material/Replay';
import { useNavigate } from 'react-router-dom';
import Close from '@mui/icons-material/Close';
import { useAuth } from '../../../../helpers/context';
import { toast } from 'react-toastify';

const totalTriesNumber = 100;

export default function ConnectWithWhatsApp({ setPopup }) {

  const { t, i18n } = useTranslation();
  const [QR, setQR] = useState('');
  const [numberOfTries, setNumberOfTries] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [whatsConnectionType, setWhatsConnectionType] = useState(-1);
  
  const history = useNavigate();
  const [msg, setMsg] = useState('');
  const [changePhoneDialog, setChangePhoneDialog] = useState(false);
  const [linkWithCustomNumberDialog, setLinkWithCustomNumberDialog] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmittingData, setIsSubmittingData] = useState(false);
  const [number, setNumber] = useState('');
  const { token, UserId, UserType, vendor } = useAuth();
  const [WlUser, setWlUser] = useState();
  
  useEffect(() => {
    if (token) {
      if (UserType !== '5') {
        getWLProfile({ userName: vendor, language: i18n.language === 'ar' ? '0' : '1' }).then((_userInfo) => {
          if (_userInfo.resCode === 0) {
            setNumber(trimPhone(_userInfo.response.wlUser.whatsapp));
            setWlUser(_userInfo.response.wlUser);
            // socket.emit("createSession", {
            //   phone: trimPhone(_userInfo.response.wlUser.whatsapp)
            // });
            callConnectEP();
            setWhatsConnectionType(_userInfo.response.wlUser.whatsType || 0)

          }
        });
      } else {
        getUserProile({ userId: token, language: i18n.language === 'ar' ? '0' : '1' }).then((_userInfo) => {
          if (_userInfo.resCode === 0) {
            setNumber(trimPhone(_userInfo.response.userProfile.phone));
            // socket.emit("createSession", {
            //   phone: trimPhone(_userInfo.response.userProfile.phone)
            // });
            callConnectEP();
          }
        });
      }
    
    }
  },  // eslint-disable-next-line
    [token, vendor, UserType]);


  const handleLogOut = () => {
    setIsSubmittingData(true);
    if (whatsConnectionType === 1) {
      saveWLProfile({
        ...WlUser,
        userId: token,
        language: i18n.language === 'ar' ? '0' : '1',
        whatsType: 0
      }).then(res => {
        if (res.resCode === 0) {
          setWhatsConnectionType(0);
        } else {
          toast.error(res.resStr);
        }
      }).finally(() => setIsSubmittingData(false));
    } else {
      whatsAppLogout({
        number: resolvePhonePrefix(number),
        userId: token,
        language: i18n.language === 'ar' ? '0' : '1'
      }).then(res => {
        if (res.resCode === 0) {
          // setLoadingQR(false);
          saveWLProfile({
            ...WlUser,
            userId: token,
            language: i18n.language === 'ar' ? '0' : '1',
            whatsType: 1
          });
          setIsLoggedIn(false);
          setWhatsConnectionType(1);
          setQR("");
          setMsg("QR code not ready yet");
          setTimeout(() => {
            setNumberOfTries(0);
          }, 500);
          // socket.emit("createSession", {
          //   phone: resolvePhonePrefix(number)
          // });
        } else {
          toast.error(res.resStr);
        }
      }).finally(() => setIsSubmittingData(false));
    }
   
  }
    
  const getData = () => {
    if (UserType !== '5') {
      getWLProfile({ userName: vendor, language: i18n.language === 'ar' ? '0' : '1' }).then((_userInfo) => {
        if (_userInfo.resCode === 0) {
          setNumber(trimPhone(_userInfo.response.wlUser.whatsapp));
          setWlUser(_userInfo.response.wlUser);
          setWhatsConnectionType(_userInfo.response.wlUser.whatsType || 0)
        }
      });
    }
  }

  const formIsValid = () => {
    const _errors = {};
    if (!number) _errors.number = t("EnterPhoneNumber");
    setErrors(_errors);
    return Object.keys(_errors).length === 0;
  }
    
      
  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      formIsValid();
    }
  }, // eslint-disable-next-line
    [i18n.language]);
    
  useEffect(() => {
    if (numberOfTries + 1 <= totalTriesNumber && (msg === "QR code not ready yet" || QR) && whatsConnectionType === 2) {
      setTimeout(() => {
        callConnectEP();
      }, 2000);
    }
  },  // eslint-disable-next-line
    [numberOfTries, whatsConnectionType]);
    
  const callConnectEP = (afterChangingPhone = false) => {
    // setLoadingQR(true);
    connectWithWhatsApp({ userId: token, language: i18n.language === 'ar' ? '0' : '1' }).then(res => {
      if (res.resCode === 0) {
        setMsg(res.response.message || "");
        if (res.response.message === "QR code not ready yet") {
          // setLoadingQR(true);
          setNumberOfTries(old => old + 1);
        } else if (res.response.message === 'Already logged in') {
          // setLoadingQR(false);
          setIsLoggedIn(true);
          setWhatsConnectionType(2)
          setLinkWithCustomNumberDialog(false);
          setPopup?.(false);
        } else if (res.response.qr) {
          setQR(res.response.qr);
          // setLoadingQR(false);
          setNumberOfTries(old => old + 1);
        }
      } else {
        // toast.error(res.resStr);
      }
    }).finally(() => {
      if (afterChangingPhone) {
        setIsSubmittingData(false);
        setChangePhoneDialog(false);
        setNumberOfTries(0);
      }
      // setLoadingQR(false)
    });
  }
    
  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (!formIsValid()) return;
    setIsSubmittingData(true);
    if (number !== WlUser?.whatsapp) {
      let result = await saveWLProfile({
        ...WlUser,
        userId: token,
        whatsapp: resolvePhonePrefix(number),
        language: i18n.language === 'ar' ? '0' : '1',
      }).then(() => {
        getData();
      });
      if (result.resCode === 0) {
        callConnectEP(true);
      }
    } else {
      callConnectEP(true);
    }
        
  }

  return (<>
    <div className={`custom-card ${UserType !== '5' ? '' : 'without-header'}`} style={{ minHeight: 'auto' }}>
      {UserType !== '5' && (
        <div className="card-header d-flex flex-row justify-content-start align-items-center" style={{ gap: '10px' }}>
          <img alt="WhatsApp logo" src="/assets/img/logo/whatsapp-logo.png" width={50} height={50} />
          <div>
            <h4>{t("LinkWithWhatsapp")}</h4>
            <h6>{t("LinkWithWhatsappDesc")}</h6>
          </div>
        </div>
      )}
      <div className="card-body">
        {whatsConnectionType === -1 ? (
          <Skeleton variant='rectangular' sx={{
            width: '100%',
            height: '160px',
            borderRadius: '10px'
          }} />
        ) : (
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
            }}
          >
            <FormControl className='col-12 col-md-11 p-0 mt-3 mb-1'>
              <RadioGroup
                value={whatsConnectionType}
                onChange={(e) => setWhatsConnectionType(e.target.value)}
              >
                <FormControlLabel value={1} control={<Radio />} label={t("UseAmakknNumber")} />
                <FormControlLabel value={2} control={<Radio />} label={<div>
                  {t("LinkWithCustomNumber")}
                  <Button
                    style={{ width: "fit-content"}}
                    size='small'
                    className='mt-2 mt-md-0 mr-3'
                      variant='outlined'
                      disabled={isLoggedIn}
                      onClick={() => {
                        setWhatsConnectionType(2);
                        setLinkWithCustomNumberDialog(true);

                    }}>
                    {t("LinkNow")}
                  </Button>
                </div>} />
              </RadioGroup>
              {/* <RadioGroup
                  name='contract-type'
                  row
                  style={{ justifyContent: "space-evenly" }}
                  value={whatsConnectionType}>
                  <div
                    className={`custom-radio col-12 col-md-5 mb-3 ${whatsConnectionType === 1 ? "active" : ""}`}
                    onClick={(e) =>whatsConnectionType === 1 ? null :
                      openDeleteModal(
                        t("ConfirmUsage"),
                        t("AreYouSureYouWantToLinkWithTheAmakknNumber"),
                        () => {
                            saveWLProfile({
                              ...WlUser,
                              userId: token,
                              language: i18n.language === 'ar' ? '0' : '1',
                              whatsType: 1
                            }).then((res) => {
                              if (res.resCode === 0) {
                                toast.success(t("SuccessfullyLinkedWithTheAmakknNumber"));
                                setWhatsConnectionType(1);
                              }
                            });
                         
                        },
                        t("Link"))
                    }>
                    <div
                      className='d-flex align-items-center'
                      style={{ gap: "10px" }}>
                      <span>{t("UseAmakknNumber")}</span>
                    </div>
                    <div>
                      <FormControlLabel value='1' control={<Radio />} />
                    </div>
                  </div>
                  <div
                    className={`custom-radio col-12 col-md-5 mb-3 ${whatsConnectionType=== 2 ? "active" : ""}`}
                    onClick={(e) => whatsConnectionType === 2 ? null :
                      openDeleteModal(
                        t("ConfirmLinking"),
                        t("AreYouSureYouWantToLinkWithACustomNumber"),
                        () => {
                            setWhatsConnectionType(2);
                        },
                        t("Link"))
                    }>
                    <div
                      className='d-flex align-items-center'
                      style={{ gap: "10px" }}>
                      <span>{t("LinkWithCustomNumber")}</span>
                    </div>
                    <div>
                      <FormControlLabel value='2' control={<Radio />} />
                    </div>
                  </div>
                </RadioGroup> */}
            </FormControl>

            {isLoggedIn && <div className="row m-0 w-100">
          <Alert
            sx={{ "& .MuiAlert-message": { width: "100%" } }}
            severity='success'
            className='custom-alert2 custom-alert w-100 align-items-center'
          >
            <div className='w-100 d-flex justify-content-between align-items-md-center flex-column flex-md-row'>
              <span>
                {t("LinkedWithWhatsAppDesc", { number: trimPhone(number) })}
              </span>
              <LoadingButton
                style={{
                  width: "fit-content",
                  borderColor: "#222",
                  color: "#222",
                }}
                classes='btn primary-btn mt-2 mt-md-0 delete-btn'
                variant='outlined'
                handleClick={handleLogOut}
                loading={isSubmittingData}
                label={t("Logout")}
              />
            </div>
          </Alert>
        </div>
              }
              
            <LoadingButton label={t("Save")} classes="px-4 py-2 primary-btn" loading={isSubmittingData} handleClick={() => {
              setIsSubmittingData(true);
              saveWLProfile({
                ...WlUser,
                userId: token,
                language: i18n.language === 'ar' ? '0' : '1',
                whatsType: whatsConnectionType || 1
              }).then((res) => {
                if (res.resCode === 0) {
                  toast.success(t("SavedSuccessfully"));
                }
              }).finally(() => setIsSubmittingData(false));
            }} />
             
          </Box>
        )}
        
      
          
        
              
          
      </div>
    </div>
    {UserType !== '5' && (
      <Dialog
        fullWidth={true}
        maxWidth={"xs"}
        open={changePhoneDialog}
        className="custom-dialog model"
        onClose={() => setChangePhoneDialog(false)}>
        <DialogTitle>
          <div className="dialog-head">
            <div>
              <h2>{t("ChangeYourAccountWhatsAppNumber")}</h2>
            </div>
            <div className="dialog-actions">
              <span onClick={() => setChangePhoneDialog(false)} style={{ cursor: 'pointer' }}>
                <Close />
              </span>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginTop: '15px' }}>
            <FormControl error={Boolean(errors.number)} style={{ width: '175px' }}>
              <TextField
                sx={{ width: "100%" }}
                label={t("PhoneNumber")}
                size='small'
                type='text'
                InputLabelProps={{ shrink: true }}
                onChange={(e) => setNumber(resolvePersianAndArabicNumbers(e.currentTarget.value))}
                error={Boolean(errors.number)}
                value={number}
              />
            </FormControl>
            <LoadingButton
              loading={isSubmittingData}
              label={t("LinkNow")}
              handleClick={handleSubmit}
            />
          </div>
          {errors.number &&
            <div className="col-12 px-0 mt-2">
              <FormHelperText component={Box}>
                <Alert severity="error" className="custom-alert">
                  {errors.number}
                </Alert>
              </FormHelperText>
            </div>
          }
        </DialogContent>
      </Dialog>
    )}

<Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={linkWithCustomNumberDialog}
        className="custom-dialog model"
      onClose={() => {
        setLinkWithCustomNumberDialog(false);
        setWhatsConnectionType(1);
      }}>
        <DialogTitle>
          <div className="dialog-head">
            <div>
              <h2>{t("LinkWithCustomNumber")}</h2>
            </div>
            <div className="dialog-actions">
            <span onClick={() => {
              setLinkWithCustomNumberDialog(false);
              setWhatsConnectionType(1);
            }} style={{ cursor: 'pointer' }}>
                <Close />
              </span>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
        <Grid container spacing={4} className="mt-4 mb-5" alignItems={"center"}>
                <Grid item xs={12} lg={8}>
                  <ol>
                    <li>. {t("WhatsAppStep1")}</li>
                    <li>. {t("WhatsAppStep2-1")}<svg style={{ marginInline: '3px', top: '5px', position: 'relative' }} height="24px" viewBox="0 0 24 24" width="24px"><rect fill="#f2f2f2" height="24" rx="3" width="24"></rect><path d="m12 15.5c.825 0 1.5.675 1.5 1.5s-.675 1.5-1.5 1.5-1.5-.675-1.5-1.5.675-1.5 1.5-1.5zm0-2c-.825 0-1.5-.675-1.5-1.5s.675-1.5 1.5-1.5 1.5.675 1.5 1.5-.675 1.5-1.5 1.5zm0-5c-.825 0-1.5-.675-1.5-1.5s.675-1.5 1.5-1.5 1.5.675 1.5 1.5-.675 1.5-1.5 1.5z" fill="#818b90"></path></svg>
                      {t("WhatsAppStep2-2")}
                      <svg width="24" height="24" style={{ marginInline: '3px', top: '5px', position: 'relative' }} viewBox="0 0 24 24">
                        <rect fill="#F2F2F2" width="24" height="24" rx="3"></rect><path d="M12 18.69c-1.08 0-2.1-.25-2.99-.71L11.43 14c.24.06.4.08.56.08.92 0 1.67-.59 1.99-1.59h4.62c-.26 3.49-3.05 6.2-6.6 6.2zm-1.04-6.67c0-.57.48-1.02 1.03-1.02.57 0 1.05.45 1.05 1.02 0 .57-.47 1.03-1.05 1.03-.54.01-1.03-.46-1.03-1.03zM5.4 12c0-2.29 1.08-4.28 2.78-5.49l2.39 4.08c-.42.42-.64.91-.64 1.44 0 .52.21 1 .65 1.44l-2.44 4C6.47 16.26 5.4 14.27 5.4 12zm8.57-.49c-.33-.97-1.08-1.54-1.99-1.54-.16 0-.32.02-.57.08L9.04 5.99c.89-.44 1.89-.69 2.96-.69 3.56 0 6.36 2.72 6.59 6.21h-4.62zM12 19.8c.22 0 .42-.02.65-.04l.44.84c.08.18.25.27.47.24.21-.03.33-.17.36-.38l.14-.93c.41-.11.82-.27 1.21-.44l.69.61c.15.15.33.17.54.07.17-.1.24-.27.2-.48l-.2-.92c.35-.24.69-.52.99-.82l.86.36c.2.08.37.05.53-.14.14-.15.15-.34.03-.52l-.5-.8c.25-.35.45-.73.63-1.12l.95.05c.21.01.37-.09.44-.29.07-.2.01-.38-.16-.51l-.73-.58c.1-.4.19-.83.22-1.27l.89-.28c.2-.07.31-.22.31-.43s-.11-.35-.31-.42l-.89-.28c-.03-.44-.12-.86-.22-1.27l.73-.59c.16-.12.22-.29.16-.5-.07-.2-.23-.31-.44-.29l-.95.04c-.18-.4-.39-.77-.63-1.12l.5-.8c.12-.17.1-.36-.03-.51-.16-.18-.33-.22-.53-.14l-.86.35c-.31-.3-.65-.58-.99-.82l.2-.91c.03-.22-.03-.4-.2-.49-.18-.1-.34-.09-.48.01l-.74.66c-.39-.18-.8-.32-1.21-.43l-.14-.93a.426.426 0 00-.36-.39c-.22-.03-.39.05-.47.22l-.44.84-.43-.02h-.22c-.22 0-.42.01-.65.03l-.44-.84c-.08-.17-.25-.25-.48-.22-.2.03-.33.17-.36.39l-.13.88c-.42.12-.83.26-1.22.44l-.69-.61c-.15-.15-.33-.17-.53-.06-.18.09-.24.26-.2.49l.2.91c-.36.24-.7.52-1 .82l-.86-.35c-.19-.09-.37-.05-.52.13-.14.15-.16.34-.04.51l.5.8c-.25.35-.45.72-.64 1.12l-.94-.04c-.21-.01-.37.1-.44.3-.07.2-.02.38.16.5l.73.59c-.1.41-.19.83-.22 1.27l-.89.29c-.21.07-.31.21-.31.42 0 .22.1.36.31.43l.89.28c.03.44.1.87.22 1.27l-.73.58c-.17.12-.22.31-.16.51.07.2.23.31.44.29l.94-.05c.18.39.39.77.63 1.12l-.5.8c-.12.18-.1.37.04.52.16.18.33.22.52.14l.86-.36c.3.31.64.58.99.82l-.2.92c-.04.22.03.39.2.49.2.1.38.08.54-.07l.69-.61c.39.17.8.33 1.21.44l.13.93c.03.21.16.35.37.39.22.03.39-.06.47-.24l.44-.84c.23.02.44.04.66.04z" fill="#818b90"></path></svg>
                      {t("WhatsAppStep2-3")}</li>
                    <li>. {t("WhatsAppStep3")}</li>
                    <li>. {t("WhatsAppStep4")}</li>
                    <li>. {t("WhatsAppStep5")}<span style={{ display: 'inline-block', marginRight: '5px', textDecoration: 'underline', color: 'var(--main-color-one)', cursor: 'pointer' }} onClick={() => {
                      if (UserType !== '5') setChangePhoneDialog(true);
                      else history(`/admin/change-agent-phone/${UserId}`);
                    }
                    }>{t("ClickHere")}</span>
                    </li>
                  </ol>
                </Grid>
                <Grid item xs={12} lg={4} alignItems='center' justifyContent='center' className="d-flex flex-column">
                  <div className="whatsapp-qr position-relative mb-2">
                    {QR ? <img src={QR} alt="qr" /> : <Stack gap={3} justifyContent="center" alignItems="center">
                      <CircularProgress size={50} sx={{ color: '#fff' }} />
                      <p style={{ fontWeight: 400, textAlign: 'center' }}>{t("PleaseWaitForQR")}</p>
                    </Stack>}
                    {numberOfTries + 1 > totalTriesNumber && (
                      <div
                        style={{
                          width: '70%',
                          height: '70%',
                          borderRadius: '100%',
                          background: '#60AEA1',
                          color: '#fff',
                          position: 'absolute',
                          top: '30px',
                          left: '30px',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: '8px',
                          textAlign: 'center',
                          gap: '15px',
                          fontWeight: 500,
                          cursor: 'pointer'
                        }}
                        onClick={() => { setNumberOfTries(0); setMsg("QR code not ready yet"); }}>
                        <Replay />
                        <span className='text-center'>{t("ClickToReloadTheQRCode")}</span>
                      </div>
                    )}
                  </div>
                                    
                </Grid>
              </Grid>
        </DialogContent>
      </Dialog>
  </>
  );
}
